// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DrCzD","active":"styles_active__gUjIg","content":"styles_content__GH+8b"};